import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Card, CardDescription } from '@/components/ui/card';
import { WindowTabs, type BriefWindow } from '@/components/common/WindowTabs';
import { BriefView } from '@/components/brief/BriefView';
import { LoadingSkeleton } from '@/components/common/LoadingSkeleton';
import { ErrorState } from '@/components/common/ErrorState';
import { useBriefByDate } from '@/lib/queries';
import { ApiError } from '@/lib/api';

export default function BriefDetail() {
  const { date = '' } = useParams();
  const [window, setWindow] = useState<BriefWindow>('7d');
  const { data, isLoading, error } = useBriefByDate(date, window);

  return (
    <>
      <Card>
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <h1 className="text-3xl font-bold">Brief — {date}</h1>
          <Link to="/hmhwatch/briefs" className="text-accent hover:underline text-sm">
            ← Archive
          </Link>
        </div>
        <WindowTabs value={window} onChange={setWindow} />
      </Card>

      {isLoading && <LoadingSkeleton lines={6} />}
      {error instanceof ApiError && error.status === 404 && (
        <Card>
          <CardDescription>No brief for this date.</CardDescription>
        </Card>
      )}
      {error && !(error instanceof ApiError && error.status === 404) && (
        <ErrorState message={(error as Error).message} />
      )}
      {data && <BriefView brief={data} heading={`Brief ${data.briefDate}`} />}
    </>
  );
}
